<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title>
          Debtors (Total In-Debt: GHS{{ overall_debt_total | currency }})

          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="debt_headers"
            :items="debtors"
            :search="search"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:item.sn="{ item, index }">
              {{ index + 1 }}
            </template>
            <template v-slot:item.id="{ item }">
              <span
                @click="view_trans(item)"
                style="cursor: pointer; color: blue"
              >
                {{ pad(item.id, 8) }}
              </span>
            </template>

            <template v-slot:item.cust_name="{ item }">
              {{ item.cust_name + " (" + item.cust_phone + ")" }}
            </template>

            <template v-slot:item.payable_amount="{ item }">
              {{ parseFloat(item.payable_amount) | currency }}
            </template>
            <template v-slot:item.total_paid="{ item }">
              {{
                item.debtpayments
                  ? sumpayments(item.debtpayments)
                  : 0 | currency
              }}
            </template>

            <template v-slot:item.balance="{ item }">
              {{
                (item.payable_amount - sumpayments(item.debtpayments))
                  | currency
              }}
            </template>

            <template v-slot:item.status="{ item }">
              <v-chip
                :color="
                  sumpayments(item.debtpayments) == item.payable_amount
                    ? 'success'
                    : 'error'
                "
              >
                {{
                  sumpayments(item.debtpayments) == item.payable_amount
                    ? "Fully Paid"
                    : "Owing"
                }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                color="primary"
                icon
                text
                @click="show_dp('pay', item)"
                :disabled="
                  item.payable_amount - sumpayments(item.debtpayments) <= 0
                "
              >
                <v-icon>money</v-icon>
              </v-btn>
              <v-btn color="pink" icon text @click="show_dp('view', item)">
                <v-icon>visibility</v-icon>
              </v-btn>
            </template>

            <!-- <template v-slot:items="props">
              <td class="text-xs-center">{{ props.index+1 }}</td>
              <td
                @click="view_trans(props.item)"
                style="cursor:pointer;color:blue;"
              >{{ pad(props.item.id,8) }}</td>
              <td class="text-xs-center">{{ props.item.cust_name +' ('+props.item.cust_phone+')' }}</td>
              <td class="text-xs-center">{{ props.item.payable_amount | currency }}</td>
              <td
                class="text-xs-center"
              >{{ props.item.debtpayments?sumpayments(props.item.debtpayments):0 | currency }}</td>
              <td
                class="text-xs-center"
              >{{props.item.payable_amount - sumpayments(props.item.debtpayments) | currency}}</td>
              <td
                class="text-xs-center"
                v-bind:class="[sumpayments(props.item.debtpayments)==props.item.payable_amount?'success':'warning']"
              >{{sumpayments(props.item.debtpayments)==props.item.payable_amount?'Fully Paid':'Owing' }}</td>
              <td class="text-xs-center">{{ props.item.staff }}</td>
              <td class="text-xs-center">
                <v-btn
                  color="primary"
                  icon
                  flat
                  @click="show_dp('pay',props.item)"
                  :disabled="(props.item.payable_amount- sumpayments(props.item.debtpayments)<=0)"
                >
                  <v-icon>money</v-icon>
                </v-btn>
                <v-btn color="pink" icon flat @click="show_dp('view',props.item)">
                  <v-icon>visibility</v-icon>
                </v-btn>
              </td>
            </template> -->
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- for viewing past transactions -->
      <v-dialog v-model="v_trans_dialog" max-width="430">
        <receipt>
          <template v-slot:shop-info>
            <shopinf></shopinf>
            <p>{{ v_trans_model.created_at }}</p>
            <p>#{{ pad(v_trans_model.id, 8) }}</p>
          </template>
          <template v-slot:item-list>
            <v-data-table
              :headers="ritems_headers"
              :items="v_trans_model.items"
              hide-default-footer
              class="elevation-0"
            >
              <template v-slot:item.unit_price="{ item }">
                {{ parseFloat(item.unit_price) | currency }}
              </template>

              <template v-slot:item.total="{ item }">
                {{ parseFloat(item.total) | currency }}
              </template>

              <!-- <template v-slot:items="props">
                <td>{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.squantity }}</td>
                <td class="text-xs-center">{{ props.item.unit_price | currency }}</td>
                <td class="text-xs-center">{{ props.item.total | currency }}</td>
              </template> -->
            </v-data-table>
          </template>

          <template v-slot:cost-summary>
            <p style="text-align: right">
              Sub-Total: GH&#8373; {{ v_trans_model.cum_amt | currency }}
            </p>
            <p style="text-align: right">VAT: {{ v_trans_model.vat_perc }} %</p>
            <p style="text-align: right">
              Discount: {{ v_trans_model.discount_perc }} %
            </p>
            <p style="text-align: right; font-weight: bold">
              Grand Total: GH&#8373;
              {{ v_trans_model.payable_amount | currency }}
            </p>
          </template>

          <template v-slot:payment-info>
            <p>Mode of Payment: {{ v_trans_model.mop }}</p>
            <p>
              Amount Tendered: GH&#8373;
              {{ v_trans_model.amt_tendered | currency }}
            </p>
            <p>Change: GH&#8373; {{ v_trans_model.change_due | currency }}</p>
          </template>

          <template v-slot:customer-info>
            <p>Customer Name: {{ v_trans_model.cust_name }}</p>
            <p>Customer Phone: {{ v_trans_model.cust_phone }}</p>
            <p>Customer Address: {{ v_trans_model.cust_address }}</p>
          </template>

          <template v-slot:tu-note>
            <p>Thank you for your partronage</p>
          </template>
        </receipt>
      </v-dialog>

      <!-- debt payment dialog -->
      <v-dialog v-model="dp" max-width="700" :persistent="pers">
        <v-form ref="form">
          <v-card>
            <v-card-title>
              <h4>Debt Payments</h4>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap v-if="dp_action == 'pay'">
                <v-flex xs12>
                  <v-text-field
                    readonly
                    label="Receipt No."
                    v-model="dp_rcptNo"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    readonly
                    label="Remaining Debt (GHS)"
                    v-model="dp_remaining"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Amount"
                    v-model="dp_model.amount"
                    :rules="amtRules"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs12>
                  <v-card>
                    <v-card-title>
                      <h5>Payments</h5>
                    </v-card-title>
                    <v-card-text>
                      <v-data-table
                        :headers="dp_payment_headers"
                        :items="selectedDebtPayments"
                        hide-default-footer
                        item-key="items.key"
                      >
                        <template v-slot:item.created_at="{ item }">
                          {{
                            moment(new Date(item.created_at)).format(
                              "DD-MM-YYYY @ h:mm:ss A"
                            )
                          }}
                        </template>
                        <template v-slot:item.amount="{ item }">
                          {{ parseFloat(item.amount) | currency }}
                        </template>

                        <template v-slot:item.actions="{ item, index }">
                          <v-btn
                            text
                            icon
                            color="pink"
                            @click="deletePayment(item, index)"
                            v-if="
                              current_user.user_details.role == 'administrator'
                            "
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                          <v-btn text icon disabled v-else>
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </template>

                        <!-- <template v-slot:items="props">
                          <td class="text-xs-center">
                            {{
                              moment(new Date(props.item.created_at)).format(
                                "DD-MM-YYYY @ h:mm:ss A"
                              )
                            }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.amount | currency }}
                          </td>
                          <td class="text-xs-center">
                            {{ props.item.received_by }}
                          </td>
                          <td class="text-xs-center">
                            <v-btn
                              flat
                              icon
                              color="pink"
                              @click="deletePayment(props.item, props.index)"
                              v-if="
                                current_user.user_details.role ==
                                'administrator'
                              "
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <v-btn flat icon disabled v-else>
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template> -->
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                v-if="dp_action == 'pay'"
                @click="makePayment()"
                :loading="dloading"
                >Pay</v-btn
              >
              <v-btn color="error" @click="hide_dp()">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>
    <snackbar ref="sb"></snackbar>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import shopinf from "../shared/shopDetails";
import receipt from "../shared/trans_receipt";
import snackbar from "../shared/snackbar";
export default {
  components: {
    receipt,
    shopinf,
    snackbar,
  },
  data() {
    return {
      moment: moment,
      search: "",
      editedIndex: -1,
      v_trans_dialog: false,
      pers: false,
      dp: false,
      dp_remaining: "",
      dp_action: "",
      dp_rcptNo: "",
      dp_model: {
        transaction_id: "",
        amount: "",
        received_by: "",
      },
      dp_modelcp: {
        transaction_id: "",
        amount: "",
        received_by: "",
      },
      dp_payment_headers: [
        {
          text: "Date",
          align: "center",
          sortable: false,
          value: "created_at",
        },
        {
          text: "Amount",
          align: "center",
          sortable: false,
          value: "amount",
        },
        {
          text: "Received By",
          align: "center",
          sortable: false,
          value: "received_by",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      debt_headers: [
        {
          text: "SN.",
          align: "center",
          sortable: true,
          value: "sn",
        },
        {
          text: "Receipt No.",
          align: "center",
          sortable: false,
          value: "id",
        },
        {
          text: "Customer",
          align: "center",
          sortable: true,
          value: "cust_name",
        },
        {
          text: "Total Debt",
          align: "center",
          sortable: false,
          value: "payable_amount",
        },
        {
          text: "Total Paid",
          align: "center",
          sortable: false,
          value: "total_paid",
        },
        {
          text: "Remaining Debt",
          align: "center",
          sortable: false,
          value: "balance",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
        },
        {
          text: "Sale Staff",
          align: "center",
          sortable: true,
          value: "staff",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      ritems_headers: [
        {
          text: "ITEM",
          align: "center",
          sortable: false,
          value: "name",
        },
        {
          text: "QTY.",
          align: "center",
          sortable: false,
          value: "squantity",
        },
        {
          text: "PRICE",
          align: "center",
          sortable: false,
          value: "unit_price",
        },
        {
          text: "AMOUNT",
          align: "center",
          sortable: false,
          value: "total",
        },
      ],
      v_trans_model: {
        items: [],
        vat_perc: 0.0,
        discount_perc: 0.0,
        mop: "Cash", //mode of payment
        staff: "",
        cum_amt: 0.0, //cumulative amount
        payable_amount: 0.0,
        amt_tendered: 0.0,
        change_due: 0.0,
        cust_name: "",
        cust_phone: "",
        cust_address: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      current_user: "Auth/CURRENT_USER",
      debtors: "Debtors/DEBTORS",
      selectedDebtPayments: "DebtPayments/SELECTEDDEBTPAYMENTS",
      errors: "Debtors/DEBTOR_ERROR",
      loading: "Debtors/DEBTORS_LOADING",
      dloading: "DebtPayments/DEBTPAYMENTS_LOADING",
      derrors: "DebtPayments/DEBTPAYMENT_ERROR",
    }),
    amtRules() {
      return [
        //(this.password === this.rePassword) || 'Password must match',
        this.dp_model.amount > 0 || "Amount must be greater than 0",
        this.dp_model.amount <= this.dp_remaining ||
          "Amount must not be greater than remaining debt",
        this.dp_model.amount !== "" || "Amount is required",
      ];
    },
    overall_debt_total() {
      let dt = this.debtors
        ? this.debtors
            .map((x) => {
              return x.payable_amount - this.sumpayments(x.debtpayments);
            })
            .reduce((sum, tot) => {
              return (sum += parseFloat(tot));
            }, 0)
        : 0;

      return dt;
    },
  },
  created() {
    this.$store.dispatch("Debtors/getAll");
  },
  mounted() {
    this.dp_model.received_by = this.current_user.user_details.name;
    this.dp_modelcp.received_by = this.current_user.user_details.name;
  },
  methods: {
    pad(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    },
    view_trans(val) {
      this.v_trans_model = val;
      this.v_trans_dialog = true;
    },
    sumpayments(val) {
      let c = val.reduce((sum, payment) => {
        return sum + parseFloat(payment.amount);
      }, 0);

      return c ? c : 0;
    },
    show_dp(action, debt) {
      //manage debt payment and viewing modal
      this.dp_remaining =
        debt.payable_amount - this.sumpayments(debt.debtpayments);
      this.editedIndex = this.debtors.indexOf(debt);
      this.pers = action == "pay" ? false : true; //set modal persistence based on action supplied. Make persistent of action is not 'pay'
      this.$store.dispatch("DebtPayments/selectedDebt", debt);
      this.dp_action = action;
      this.dp_rcptNo = this.pad(debt.id, 8);
      this.dp_model.transaction_id = debt.id;
      this.dp = true;
    },
    hide_dp() {
      this.editedIndex = -1;
      this.dp_rcptNo = "";
      this.dp_remaining = "";
      // this.dp_model = this.dp_modelcp;
      this.dp = false;
    },
    makePayment() {
      var sb = this.$refs.sb;
      if (this.$refs.form.validate()) {
        this.$store.dispatch("DebtPayments/add", this.dp_model);

        if (this.derrors == null) {
          //this.dp_model = this.dp_modelcp
          this.dp = false;
          this.snackbarconf(sb, "Payment made successfully", "success");
        } else {
          this.snackbarconf(sb, "Sorry, payment was unsuccessful", "error");
        }
      }
    },
    deletePayment(dp, index) {
      var sb = this.$refs.sb;
      if (confirm("Are you sure you want to delete this payment?")) {
        this.$store.dispatch("DebtPayments/delete", {
          index: index,
          debtpayment: dp,
        });
        if (this.derrors == null) {
          this.dp_model = this.dp_modelcp;
          //this.dp = false
          this.snackbarconf(sb, "Payment deleted successfully", "success");
        } else {
          this.snackbarconf(sb, "Sorry, payment could not be deleted", "error");
        }
      }
    },
    snackbarconf(snackbar, message, color) {
      snackbar.text = message;
      snackbar.color = color;
      snackbar.snackbar = true;
    },
  },
  watch: {
    dp(val) {
      if (val == false) {
        this.dp_model = {
          transaction_id: "",
          amount: "",
          received_by: "",
        };
        this.dp_model.received_by = this.current_user.user_details.name;
        this.dp_remaining = "";
      }
    },
  },
};
</script>